import { CONTRACT_DETAILS } from './index';
import { Action } from '../action';

export class ContractDetailsInitAction implements Action {
	readonly type = CONTRACT_DETAILS.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractDetailsDestroyAction implements Action {
	readonly type = CONTRACT_DETAILS.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractDetailsClickCancelAction implements Action {
	readonly type = CONTRACT_DETAILS.CLICK_CANCEL;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractDetailsClickPpaUpdateAction implements Action {
	readonly type = CONTRACT_DETAILS.CLICK_PPA_UPDATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ContractDetailsClickCcUpdateAction implements Action {
	readonly type = CONTRACT_DETAILS.CLICK_CC_UPDATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
